import React from 'react';

const Country = (props) => {
    console.log(props)
    console.log(props.length);
    const {
        name,
        area,
        capital,
        flag,
        languages,
        currencies,
        population,
        timezones,
        region } = props.country;

    const index = props.index + 1;
    // console.log(props.index);
    const flagStyle = {
        width: '25px'
    }
    return (
        <tbody>
            <tr>
                <th >{index}</th>
                <td>{name}</td>
                <td> {area} </td>
                <td> {capital} </td>
                <td> <img style={flagStyle} src={flag} alt="" /> </td>
                <td> {languages[0].nativeName} </td>
                <td> {currencies[0].symbol} {currencies[0].code} </td>
                <td> {population} </td>
                <td> {timezones[0]} </td>
                <td> {region} </td>
            </tr>
        </tbody>
    );
};

export default Country;